import {
    LayerCloseHandleV2,
    LayerHandleV2,
    LayerManagerV2,
} from '@volkswagen-onehub/layer-manager'
import React from 'react'
import {Provider} from 'react-redux'
import {AlertSystemLayer} from '../AlertSystemLayer'
import store from '../../../store'
import {ThemedLayerProvider} from '../../../../shared/ThemedLayerProvider'

function AlertSystemRenderLayer(
    state: any,
    close: LayerCloseHandleV2<any>
): React.JSX.Element {
    return (
        <Provider store={store}>
            <ThemedLayerProvider>
                <AlertSystemLayer
                    state={state}
                    onClickClose={() => close('layerContent')}
                />
            </ThemedLayerProvider>
        </Provider>
    )
}

let localLayerManager: LayerManagerV2
let layer: LayerHandleV2<{message: string | undefined}>

export const setAlertSystemLayerHandle = (layerManager: LayerManagerV2) => {
    localLayerManager = layerManager
}

export const openAlertSystemLayer = (message?: string) => {
    layer = localLayerManager.openAlert(AlertSystemRenderLayer, {
        message,
    })
}

export const closeAlertSystemLayer = () => {
    layer.close()
}
